<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb" v-if="parentMenuId">
                <li>
                    <router-link :to="{ name: 'memuList', query: { roleLevel: roleLevel } }">菜单管理</router-link>
                </li>
                <li class="active">子级菜单</li>
            </ol>
            <ol class="breadcrumb" v-else>
                <li class="active">菜单管理</li>
            </ol>
        </div>
        <div class="content-query content-border">
            <form action="" class="form-inline">
                <div class="form-group">
                    <el-button class="btn btn-primary" type="success" size="small" icon="el-icon-circle-plus-outline" round  v-if="authMenus['M6872']" @click="$common.goRouterLink({ name: 'memuDetail', query: { parentMenuId: parentMenuId, roleLevel: roleLevel}})">添加</el-button>
                    <el-button class="btn btn-primary" type="primary" size="small" icon="el-icon-search" @click="submitQuery(1)">刷新</el-button>
                    <el-button v-if="parentMenuId" class="btn btn-primary" type="primary" size="small" icon="el-icon-back" @click="$router.go(-1)">返回</el-button>
                </div>
            </form>
        </div>
        <hr />
        <div class="title">
            <span>菜单管理</span>
        </div>
        <div class="content-data" v-if="0 < menus.length">
            <el-table highlight-current-row :data="menus" border>
                <el-table-column align="center" type="index"></el-table-column>
                <el-table-column align="center" label="名称">
                    <template slot-scope="scope">
                        <span>{{scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="级别">
                    <template slot-scope="scope">
                        <span>{{scope.row.level}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="bindurl">
                    <template slot-scope="scope">
                        <span>{{scope.row.bindurl}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="参数">
                    <template slot-scope="scope">
                        <span>{{scope.row.parameter}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="上级">
                    <template slot-scope="scope">
                        <span>{{scope.row.parentName}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="顺序">
                    <template slot-scope="scope">
                        <span>{{scope.row.sequence}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="编码">
                    <template slot-scope="scope">
                        <span>{{scope.row.code}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" fixed="right" width="400px" label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" round @click="$common.goRouterLink({ name: 'memuDetail', query: { menuId: scope.row.id, roleLevel: roleLevel }})">详情</el-button>
                        <el-button type="success" icon="el-icon-circle-plus-outline"  size="mini" round v-if="authMenus['M6872']" @click="$common.goRouterLink({ name: 'memuDetail', query: { parentMenuId: scope.row.id, roleLevel: roleLevel}})">添加下级菜单</el-button>
                        <el-button type="primary" size="mini" round @click="$common.goRouterLink({ name: 'memuList', query: { parentMenuId: scope.row.id, roleLevel: roleLevel } })">查看下级菜单</el-button>
                        <el-button v-if="authMenus['M5511']" @click="deleteMenu(scope.row.id)" type="danger" size="mini" round>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="content-data" v-else>
            没有查询到数据
        </div>
        <vue-pager v-bind:datafile="fillData" url="/menu/pageMenu" v-bind:query="query" ref="pager" v-bind:init="true"></vue-pager>
    </div>
</template>
<script>
export default {
    data() {
        return {
            menus: [],
            query: {},
            parentMenuId:'',
            roleLevel: 1,
            authMenus: {},
        }
    },
    created() {
        var _this = this;
        _this.parentMenuId = _this.$route.query.parentMenuId;
        _this.roleLevel = _this.$route.query.roleLevel || 1;
        _this.query.parentId = _this.parentMenuId;
        _this.query.roleLevel = _this.roleLevel;
        if (!_this.parentMenuId) {
            _this.query.menuLevel = 0;
            _this.query.level = 0;
        }
        _this.authMenus =_this.$common.cache("menus");
    },
    methods: {
        fillData(_response) {
            var _this = this;
            _this.menus = _response.items || [];
        },
        submitQuery(_num) {
            var _this = this;
            _this.menus = [];
            _this.$refs.pager.gotoPage(_num);
        },
        deleteMenu: function(_menuId) {
            var _this = this;
            _this.$confirm('是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.$common.my_ajax({
                    url: 'menu/deleteMenu',
                    data: {
                        menuId: _menuId
                    },
                    success: function(response) {
                        // 刷新菜单列表
                        _this.$common.refreshUserMenuAuth(_this.$common.user_info().userId);
                        _this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 1000,
                            onClose: function() {
                                _this.submitQuery();
                            }
                        });
                    }
                });
            }).catch(() => {
                console.log('取消删除');
            });
        },
    },
    watch: {
        '$route' (to, from) {
            var _this = this;
            if (to.name == from.name) {
                _this.query = {};
                _this.parentMenuId = _this.$route.query.parentMenuId;
                _this.roleLevel = _this.$route.query.roleLevel;
                _this.query.parentId = _this.parentMenuId;
                _this.query.roleLevel = _this.roleLevel;
                if (!_this.parentMenuId) {
                    _this.query.menuLevel = 0;
                }
                _this.menus = [];
                _this.$nextTick(function() {
                    _this.$refs.pager.gotoPage(1);
                });
            }
        }
    },
}
</script>
<style scoped>
td {
    text-align: center;
}
</style>